import { ActionIcon } from "@mantine/core"
import { IconArrowsSplit } from "@tabler/icons-react"

interface SplitButtonProps {
  onClick: () => void
}
export const SplitButton = ({ onClick }: SplitButtonProps) => {
  return (
    <ActionIcon
      variant="outline"
      color="green"
      size="sm"
      mt={25}
      onClick={onClick}
    >
      <IconArrowsSplit />
    </ActionIcon>
  )
}
